import axios from 'axios'

import api from '../api';


export default class AssetCategoryService {
    async getAssetCategoryListing(obj) {
        return await api.post(`AssetCategory/GetAssetCategories`,obj);
    };
    async getAttributeListing(obj) {
        return await api.post(`AssetCategory/GetAssetCategoryAttributes`,obj);
    };
    async deleteAssetCategory(obj) {
        return await api.post(`AssetCategory/DeleteAssetCategory`, obj);
    };
    async deleteCategoryAttribute(obj) {
        return await api.post(`AssetCategory/DeleteCategoryAttribute`, obj);
    };
    async addEditAssetCategory(dataModel) {
        return await api.post(`AssetCategory/AddEditAssetCategory`, dataModel);
    };
    async SaveFile(formData) {
        return await api.post(`AssetCategory/SaveFile`, formData, {
            "Content-Type": "multipart/form-data"
        });
    };

    async addEditAssetCategoryAttribute(dataModel) {
        return await api.post(`AssetCategory/addEditAssetCategoryAttribute`, dataModel);
    };


    async ActiveInactiveAssetCategory(id, status, userId, companyId) {
        return await api.get(`AssetCategory/ActiveInactiveAssetCategory/${id}/${status}/${userId}/${companyId}`)
    }


    async ActiveInactiveAssetCategoryAttribute(id, status, userId, companyId) {
        return await api.get(`AssetCategory/ActiveInactiveAssetCategoryAttribute/${id}/${status}/${userId}/${companyId}`)
    }

    async MapAttributeToCompany(assetCategoryId, companyId, userId, isAdded) {
        return await api.get(`AssetCategory/MapAttributeToCompany/${assetCategoryId}/${companyId}/${userId}/${isAdded}`)
    }
}